import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-accent-500 rounded-lg flex items-center justify-center">
                <i className="ri-quill-pen-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-background-50 whitespace-nowrap">
                17.c-起草口
              </span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed">
              专业的在线文案起草平台，提供一站式草稿撰写、内容规划与文件起草服务。助您高效完成每一份草稿。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">服务分类</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/category" className="text-foreground-400 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">商务文件</Link></li>
              <li><Link to="/category" className="text-foreground-400 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">创意文案</Link></li>
              <li><Link to="/category" className="text-foreground-400 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">法律文书</Link></li>
              <li><Link to="/category" className="text-foreground-400 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">行政公文</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-foreground-400 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category" className="text-foreground-400 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">分类浏览</Link></li>
              <li><Link to="/about" className="text-foreground-400 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">联系方式</h4>
            <ul className="flex flex-col gap-2.5 text-foreground-400 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>contact@zhimycloud.cn</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400"></i>
                <span>400-888-1717</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400"></i>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {currentYear} 17.c-起草口 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 text-xs hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}